export default __webpack_public_path__ + "static/media/main2_m.2671d77d.jpg";